//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file example/testing/rpc.proto.
 */
export const file_example_testing_rpc = /*@__PURE__*/ fileDesc("ChlleGFtcGxlL3Rlc3RpbmcvcnBjLnByb3RvEhNleGFtcGxlLnRlc3RpbmcucnBjIh4KDlRlc3RScGNSZXF1ZXN0EgwKBGRhdGEYASABKAkiHwoPVGVzdFJwY1Jlc3BvbnNlEgwKBGRhdGEYASABKAkiXQoUVGVzdFN0cmVhbVJwY1JlcXVlc3QSDAoEZGF0YRgBIAEoCRIaChJzdHJlYW1Mb2FkSW50ZXJ2YWwYAiABKA0SGwoTc3RyZWFtTG9hZENodW5rU2l6ZRgDIAEoDSKPAQoVVGVzdFN0cmVhbVJwY1Jlc3BvbnNlEgwKBGRhdGEYASABKAkSEQoJYnl0ZXNTZW50GAIgASgNEhUKDWJ5dGVzUmVjZWl2ZWQYAyABKA0SEgoKc2VuZEVycm9ycxgEIAEoDRIVCg1yZWNlaXZlRXJyb3JzGAUgASgNEhMKC3J1bm5pbmdUaW1lGAYgASgNIhwKC1BpbmdSZXF1ZXN0Eg0KBW5vbmNlGAEgASgFIhwKC1BpbmdSZXBvbnNlEg0KBW5vbmNlGAEgASgFIjcKDk1lc3NhZ2VXaXRoQW55EiUKB3BheWxvYWQYASABKAsyFC5nb29nbGUucHJvdG9idWYuQW55MqABCgtUZXN0U2VydmljZRJVCghUZXN0Q2FsbBIjLmV4YW1wbGUudGVzdGluZy5ycGMuVGVzdFJwY1JlcXVlc3QaJC5leGFtcGxlLnRlc3RpbmcucnBjLlRlc3RScGNSZXNwb25zZRI6CghWb2lkQ2FsbBIWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eTJsChFUZXN0U3RyZWFtU2VydmljZRJXCghUZXN0Q2FsbBIjLmV4YW1wbGUudGVzdGluZy5ycGMuVGVzdFJwY1JlcXVlc3QaJC5leGFtcGxlLnRlc3RpbmcucnBjLlRlc3RScGNSZXNwb25zZTABMuIBChZUZXN0U2VydmljZVdpdGhTdHJlYW1zEmQKEVJlcXVlc3RUZXN0U3RyZWFtEikuZXhhbXBsZS50ZXN0aW5nLnJwYy5UZXN0U3RyZWFtUnBjUmVxdWVzdBokLmV4YW1wbGUudGVzdGluZy5ycGMuVGVzdFJwY1Jlc3BvbnNlEmIKD0Nsb3NlVGVzdFN0cmVhbRIjLmV4YW1wbGUudGVzdGluZy5ycGMuVGVzdFJwY1JlcXVlc3QaKi5leGFtcGxlLnRlc3RpbmcucnBjLlRlc3RTdHJlYW1ScGNSZXNwb25zZTJZCgtQaW5nU2VydmljZRJKCgRQaW5nEiAuZXhhbXBsZS50ZXN0aW5nLnJwYy5QaW5nUmVxdWVzdBogLmV4YW1wbGUudGVzdGluZy5ycGMuUGluZ1JlcG9uc2UyZgoOVGVzdEFueVNlcnZpY2USVAoIVGVzdENhbGwSIy5leGFtcGxlLnRlc3RpbmcucnBjLk1lc3NhZ2VXaXRoQW55GiMuZXhhbXBsZS50ZXN0aW5nLnJwYy5NZXNzYWdlV2l0aEFueUI0WjJnaXRodWIuY29tL2R4b3MvZHhvcy9wcm90by9kZWYvZXhhbXBsZS90ZXN0aW5nL3JwY2IGcHJvdG8z", [file_google_protobuf_any, file_google_protobuf_empty]);
/**
 * Describes the message example.testing.rpc.TestRpcRequest.
 * Use `create(TestRpcRequestSchema)` to create a new message.
 */
export const TestRpcRequestSchema = /*@__PURE__*/ messageDesc(file_example_testing_rpc, 0);
/**
 * Describes the message example.testing.rpc.TestRpcResponse.
 * Use `create(TestRpcResponseSchema)` to create a new message.
 */
export const TestRpcResponseSchema = /*@__PURE__*/ messageDesc(file_example_testing_rpc, 1);
/**
 * Describes the message example.testing.rpc.TestStreamRpcRequest.
 * Use `create(TestStreamRpcRequestSchema)` to create a new message.
 */
export const TestStreamRpcRequestSchema = /*@__PURE__*/ messageDesc(file_example_testing_rpc, 2);
/**
 * Describes the message example.testing.rpc.TestStreamRpcResponse.
 * Use `create(TestStreamRpcResponseSchema)` to create a new message.
 */
export const TestStreamRpcResponseSchema = /*@__PURE__*/ messageDesc(file_example_testing_rpc, 3);
/**
 * Describes the message example.testing.rpc.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema = /*@__PURE__*/ messageDesc(file_example_testing_rpc, 4);
/**
 * Describes the message example.testing.rpc.PingReponse.
 * Use `create(PingReponseSchema)` to create a new message.
 */
export const PingReponseSchema = /*@__PURE__*/ messageDesc(file_example_testing_rpc, 5);
/**
 * Describes the message example.testing.rpc.MessageWithAny.
 * Use `create(MessageWithAnySchema)` to create a new message.
 */
export const MessageWithAnySchema = /*@__PURE__*/ messageDesc(file_example_testing_rpc, 6);
/**
 * @generated from service example.testing.rpc.TestService
 */
export const TestService = /*@__PURE__*/ serviceDesc(file_example_testing_rpc, 0);
/**
 * @generated from service example.testing.rpc.TestStreamService
 */
export const TestStreamService = /*@__PURE__*/ serviceDesc(file_example_testing_rpc, 1);
/**
 * @generated from service example.testing.rpc.TestServiceWithStreams
 */
export const TestServiceWithStreams = /*@__PURE__*/ serviceDesc(file_example_testing_rpc, 2);
/**
 * @generated from service example.testing.rpc.PingService
 */
export const PingService = /*@__PURE__*/ serviceDesc(file_example_testing_rpc, 3);
/**
 * @generated from service example.testing.rpc.TestAnyService
 */
export const TestAnyService = /*@__PURE__*/ serviceDesc(file_example_testing_rpc, 4);
//# sourceMappingURL=rpc_pb.js.map